import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Dialog from 'components/Dialog';
import { Card, CardContent } from '@material-ui/core';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import { changePass } from 'reducers/UserReducer';
import TextField from 'components/TextField2';
import { RowInner } from 'utils/formStyles';
import { CircularProgress } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { notify } from 'reducers/NotifierReducer';
import { passValidationErrors } from 'utils/functions';
import { closeChangePasswordDialog } from 'reducers/DialogsReducer';

const useStyles = makeStyles(() => ({
  title: {
    background: '#0051a0',
    color: '#fff',
    minHeight: 60,
    marginBottom: 10,
    alignContent: 'center',
    '& h6': {
      fontSize: 20,
      fontWeight: 400,
      textAlign: 'left',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    textAlign: 'center',
    width: 480,
    minHeight: 150,
    padding: '0px',
  },
  card: {
    width: 480,
    height: 480,
    background: 'fff',
    '& img': {
      width: '100%',
    },
  },
  actions: {
    textAlign: 'center',
    '& button': {
      background: '#0051a0',
      color: '#fff',
      paddingLeft: '3em',
      paddingRight: '3em',
      textTransform: 'uppercase',
      '&:hover': {
        background: '#021090',
      },
    },
  },
  footer: {
    padding: '16px',
    textAlign: 'center',
    top: 395,
    right: 150,
    position: 'absolute',
  },
  action: {
    marginBottom: 10,
  },

  form: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: 10,
    justifyContent: 'center',
  },
  w150x250: {
    maxWidth: 250,
    minWidth: 450,
  },
  items: {
    justifyContent: 'center',
  },
  alert: {
    width: 450,
    marginBottom: 16,
    '& ul': {
      padding: 0,
    },
  },
}));

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

function ChangePasswordDialog(props) {
  const classes = useStyles();
  const { Username } = props;
  const [oldPass, setOldPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirmNewPass, setConfirmNewPass] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errors, setErrors] = useState([]);
  const disabled = Boolean(error || !oldPass || !newPass || loading || newPass !== confirmNewPass);
  const repeatPassErr = newPass === confirmNewPass ? false : "Passwords don't match";

  React.useEffect(() => {
    const validationErrors = passValidationErrors(Username, newPass);
    if (newPass && validationErrors.length) {
      setError(validationErrors[0]);
    } else {
      if (error) setError(false);
    }
  }, [newPass]);

  const changePassword = async () => {
    setLoading(true);
    try {
      await changePass(oldPass, newPass);
      props.notify('Password updated!', 'success');
      setOldPass('');
      setNewPass('');
      setConfirmNewPass('');
      setErrors([]);
      // props.hidePassExpiration();
    } catch (err) {
      if (err.errors && err.errors.length) {
        setErrors(err.errors);
      } else {
        const message = err.message ? err.message : 'Error updating password';
        setErrors([message]);
      }
    }
    setLoading(false);
  };

  return (
    <Dialog onClose={props.closeChangePasswordDialog} open={true} title="Change password">
      <DialogContent className="p-0">
        <Card className={classes.card}>
          <CardContent className="p-0">
            <div className={classes.form}>
              {errors.length > 0 && (
                <Alert severity="error" className={classes.alert}>
                  <AlertTitle>Password validation errors</AlertTitle>
                  <ul>
                    {errors.map((err, idx) => (
                      <li key={idx}>{err}</li>
                    ))}
                  </ul>
                </Alert>
              )}
              <RowInner className={classes.items}>
                <TextField
                  className={classes.w150x250}
                  label="Previous Password"
                  placeholder="Enter your previous password"
                  value={oldPass}
                  onChange={(ev, val) => setOldPass(val)}
                  type="password"
                />
              </RowInner>
              <RowInner className={`${classes.items} mt-2`}>
                <TextField
                  className={classes.w150x250}
                  label="New Password"
                  value={newPass}
                  placeholder="Enter your new password"
                  onChange={(ev, val) => setNewPass(val)}
                  type="password"
                  error={error}
                  disabled={!oldPass}
                />
              </RowInner>
              <RowInner className={`${classes.items} mt-2`}>
                <TextField
                  className={classes.w150x250}
                  label="Repeat New Password"
                  placeholder="Enter your repeat password"
                  value={confirmNewPass}
                  onChange={(ev, val) => setConfirmNewPass(val)}
                  type="password"
                  error={repeatPassErr}
                  disabled={!oldPass}
                />
              </RowInner>
              <RowInner className={classes.items}>
                <Button
                  className={classes.w150x250}
                  color="secondary"
                  variant="contained"
                  autoFocus
                  onClick={changePassword}
                  disabled={disabled}>
                  Change Password
                </Button>
                {loading && <CircularProgress style={{ marginLeft: 8 }} />}
              </RowInner>
            </div>
          </CardContent>
        </Card>
      </DialogContent>
    </Dialog>
  );
}

export default connect(null, {
  notify,
  closeChangePasswordDialog,
})(ChangePasswordDialog);